import Vue from 'vue'
import Router from 'vue-router'
//import Login from '@/views/Login'
import Login from '@/views/Loginv2'
import Login1 from '@/views/Login1'
import Home from '@/views/Home' 
import Welcome from '@/views/Welcome' 
import NotFound from "@/views/Public/404"
import Error from "@/views/Public/Error"
import store from "@/store"
import api from "@/http/api"
import Loading from '@/views/Public/Loading'
import Init from '@/views/Init'
import NoRight from '@/views/Public/NoRight'
import Content from '@/views/Content/Index'
import DailyReport from '@/views/Public/DailyReport'
import AdminLogin from '@/views/Admin/Login'


Vue.use(Router)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      children: [
        {
          path: '', 
          name: '欢迎页', 
          component: Welcome,
          meta: {
            icon: 'fa fa-home fa-lg',
            index: 0
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/login1',
      name: 'Login1',
      component: Login1
    },
    {
      path: '/noRight',
      name: 'NoRight',
      component: NoRight
    },
    {
      path: '/loading',
      name: 'Loading',
      component: Loading
    },
    {
      path: '/init',
      name: 'Init',
      component: Init
    },
    {
      path: "/404",
      name: "notFound",
      component: NotFound
    },
    {
      path: "/error",
      name: "Error",
      component: Error
    },
    {
      path: "/content/:type",
      name: "Content",
      component: Content,
      props: true
    },
    {
      path: "/dailyReport",
      name: "DailyReport",
      component: DailyReport
    },
    {
      path: "/admin/login",
      name: "AdminLogin",
      component: AdminLogin
    }
  ]
});



//不需要做权限控制的路径
const PUBLIC_PATH = ["/login","/login1","/loading","/404","/error","/noRight","/dailyReport","/admin/login"];
//不需要加载动态菜单的路径
const NO_DYNAMICMENU_PATH = ["/init"];

router.beforeEach((to, from, next) => {
  // 登录界面登录成功之后，会把用户信息保存在会话
  // 存在时间为会话生命周期，页面关闭即失效。
  const edzUser = JSON.parse(sessionStorage.getItem("edzUser"));

  // 如果是访问登录界面，如果用户会话信息存在，代表已登录过，跳转到主页
  if (to.path === "/login") {
    if (edzUser) {
      next({ path: "/" });
    } else {
      next();
    }
  } 
  //不需要验证登陆的页面
  else if( PUBLIC_PATH.includes(to.path)){
    next();
  }
  //需要做登陆验证
  else {
    if (!edzUser) {
      // 如果访问非登录界面，且户会话信息不存在，代表未登录，则跳转到登录界面
      next({ path: "/login" });
    } else {
      // 不需要加载动态菜单和路由的路径
      if( NO_DYNAMICMENU_PATH.includes(to.path) ){
        next();
      }
      // 加载动态菜单和路由
      else{
        addDynamicMenuAndRoutes(edzUser.nick, to, from);
        next();
      }
    }
  }
});

function addDynamicMenuAndRoutes(userName, to, from) {
  if (store.state.app.menuRouteLoaded) {
    // console.log("动态菜单和路由已经存在.");
    return;
  }
  // console.log("动态菜单和路由还未加载，获取数据...");
  api.menu
    .findNavTree({ userName: userName })
    .then(res => {
      // console.log("从DB获取到菜单：",res.data);
      // 添加动态路由
      let dynamicRoutes = addDynamicRoutes(res.data);
      // console.log("添加动态路由, router0=>", router);
      // console.log("添加动态路由, child=>", router.options.routes[0].children);
      // console.log("添加动态路由, dynamicRoutes=>", dynamicRoutes);
      router.options.routes[0].children = router.options.routes[0].children.concat(
        dynamicRoutes
      );
      //判断上次动态增加的路由是否存在，如果有，就清空。
      // let children = router.options.routes[0].children
      // if (children) {
      //     children = []
      // }
      // children = children.concat(dynamicRoutes)
      // console.log("添加动态路由, router1=>", router);
      router.$addRoutes(router.options.routes);
      // console.log("添加动态路由, router2=>", router);

      // 保存加载状态
      store.commit("menuRouteLoaded", true);
      // 保存菜单树
      store.commit("setNavTree", res.data);
    })
    .then(res => {
      api.user.findPermissions({ name: userName }).then(res => {
        // 保存用户权限标识集合
        store.commit("setPerms", res.data);
      });
    })
    .catch(function(res) {});
}
/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function addDynamicRoutes(menuList = [], routes = []) {
  var temp = [];
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1) {
      // console.log("temp1:", temp);
      temp = temp.concat(menuList[i].children);
      // console.log("temp2:", temp);
    } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      //console.log("menuList url:", menuList[i].url);
      menuList[i].url = menuList[i].url.replace(/^\//, "");
      // 创建路由配置
      var route = {
        path: menuList[i].url,
        component: null,
        name: menuList[i].name,
        meta: {
          icon: menuList[i].icon,
          index: menuList[i].menuId
        }
      };

      // console.log("测试--------->", route);

      try {
        // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
        // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
        let array = menuList[i].url.split("/");
        let url = "";
        for (let i = 0; i < array.length; i++) {
          url +=
            array[i].substring(0, 1).toUpperCase() +
            array[i].substring(1) +
            "/";
        }
        url = url.substring(0, url.length - 1);
        //console.log("url:", url);
        route["component"] = resolve => require([`@/views/${url}`], resolve);
        //console.log(route);
      } catch (e) {}
      routes.push(route);
    }
  }
  if (temp.length >= 1) {
    // console.log("重新调用自身", temp, routes);
    addDynamicRoutes(temp, routes);
  } else {
    // console.log("动态路由加载...");
    //console.log(routes);
    // console.log("动态路由加载完成.");
  }
  return routes;
}
router.$addRoutes = (params) => {
  // console.log("ADD ROUTER");
  router.matcher = new Router({mode: 'history'}).matcher;
  //router.matcher = new VueRouter().matcher;
  router.addRoutes(params)
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js